import {Helmet} from "react-helmet";
import React, {useContext, useState, useEffect} from "react";
import { Row, Col, CardBody, Card, Container, Form, Input, FormFeedback, Label } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import toast from 'react-hot-toast';
import axios from "axios";
import { AuthContext } from "context/authContext";
import AppConfig from "../../constants/config";

const Login = () => {
  const navigate = useNavigate();
	const { reloadUserData } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async(values) => {
    setLoading(true);
    try {
        const {data} = await axios.post(`${AppConfig.baseUrl}/customer/login`, values);
        if(!data.error){
          formik.resetForm();
          if(data.is_2fa_active){
            await localStorage.setItem('temp_token', data.token);
            navigate("/factorauth", { state: { key: "login" } });
          }else if(!data.terms_checked){
            await localStorage.setItem('temp_token', data.token);
            navigate(`/terms_and_conditions/accept`);
          }
          else{
            await localStorage.setItem('token', data.token);
            await localStorage.setItem('company', data.company.toLowerCase());
            reloadUserData()
            if(data.is_1st_login){
              navigate("/set_password");
            }
            else{
              toast.success('Logged in Successfully');
              navigate(`/${data.company.toLowerCase()}/dashboard`);
            }
          }
        }
        else{
            throw new Error(data.title);
        }
    } catch (error) {
      toast.error(error.message == 'Network Error' ? 'Maintenance in process' : error.message);
    }
    setLoading(false);
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Plese enter valid email").required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: handleSubmit
  });

  return (
    <React.Fragment>
      <Helmet>
        <title>LeaseVista | Login</title>
      </Helmet>
      <div className="account-pages my-5 pt-sm-5 login-mt">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-softbg-soft-primary bg-theme-color">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-white login-head">Welcome To LeaseVista Customer Admin Panel</h5>
                        <p className="text-white">Sign in to continue</p>
                      </div>
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div className="p-2 mt-4">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        formik.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-3">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.email || ""}
                          invalid={
                            formik.touched.email && formik.errors.email ? true : false
                          }
                        />
                        {formik.touched.email && formik.errors.email ? (
                          <FormFeedback type="invalid">{formik.errors.email}</FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Password</Label>
                        <Input
                          name="password"
                          value={formik.values.password || ""}
                          type="password"
                          placeholder="Enter Password"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          invalid={
                            formik.touched.password && formik.errors.password ? true : false
                          }
                        />
                        {formik.touched.password && formik.errors.password ? (
                          <FormFeedback type="invalid">{formik.errors.password}</FormFeedback>
                        ) : null}
                      </div>

                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customControlInline"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customControlInline"
                        >
                          Remember me
                        </label>
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary bg-theme-color btn-block"
                          type="submit"
                          disabled={loading}
                        >
                          {
                              loading && <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i> 
                          }
                          LOGIN
                        </button>
                      </div>

                      <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock me-1" />
                          Forgot your password?
                        </Link>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Login
